module.exports = __webpack_public_path__ + "836bb47919033c9fb2442c8b0036a6a0.png";